var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { commonCssStyles } from "../../global-styles.js";
import { classMap } from "lit/directives/class-map.js";
/**
 * Exposes a shadow part called `circlecontainer` which allows who is consuming
 * changing the style for the icon
 */
let AvatarIcon = class AvatarIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.alert = false;
        /**
         * Define the icon size.
         *
         * @param val - Options: big | small
         */
        this.iconSize = "big";
    }
    /**
     * Accepts a string of 2 characters to display as initials.
     *
     * @param val - The initials to display. If the string is longer than 2 characters it will be truncated.
     */
    set initials(val) {
        if (typeof val === "string") {
            this._initials = val.substring(0, 2);
        }
    }
    get initials() {
        return this._initials;
    }
    render() {
        const small = this.iconSize === "small";
        return html `
      <div
        part="circlecontainer"
        class="initials ${classMap({
            small: small,
            big: !small,
            alert: this.alert,
            "text-xxs-semibold": small,
            "text-base-semibold": !small,
        })}"
      >
        ${this._initials}
        <div class="badge"></div>
      </div>
    `;
    }
};
// noinspection CssUnresolvedCustomProperty
AvatarIcon.styles = [
    commonCssStyles,
    css `
      .initials {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background-color: var(--tones-lavender50-color);
        color: var(--text-text-white-color);
        border-radius: 50%;
        text-align: center;
        position: relative;
      }

      .initials .badge {
        display: none;
        background-color: var(--orange-color);
        border: 2px solid var(--white-color);
        border-radius: 50%;
        position: absolute;
        top: -2px;
        right: -2px;
      }

      .alert .badge {
        display: block;
      }

      .big {
        height: 40px;
        width: 40px;
      }

      .big .badge {
        height: 12px;
        width: 12px;
      }

      .small {
        height: 24px;
        width: 24px;
      }

      .small .badge {
        height: 5px;
        width: 5px;
      }
    `,
];
__decorate([
    property({ type: Boolean, reflect: true })
], AvatarIcon.prototype, "alert", void 0);
__decorate([
    property({ type: String, attribute: "icon-size" })
], AvatarIcon.prototype, "iconSize", void 0);
__decorate([
    property()
], AvatarIcon.prototype, "initials", null);
AvatarIcon = __decorate([
    customElement("avatar-icon")
], AvatarIcon);
export { AvatarIcon };
